import script from "./ListTrainings.vue?vue&type=script&setup=true&lang=js"
export * from "./ListTrainings.vue?vue&type=script&setup=true&lang=js"

import "./ListTrainings.vue?vue&type=style&index=0&id=acc4b5ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acc4b5ac"]])

export default __exports__